import { db } from '../../firebase/config';

const sourceFieldByType = {
    MSIEffect: 'Effect',
    Effect: 'Effect',
    Output: 'Output',
    Question: 'Question',
    Targetgroup: 'Targetgroup',
    CustomEvent: 'CustomEvent',
};

const isDeletedStatus = (status) => status === 'deleted' || status === 'deleted-project';

const existsSync = async (parent, project, type, sourceId) => {
    if (!parent || !project || !type || !sourceId) return false;
    const sourceField = sourceFieldByType[type];
    if (!sourceField) return false;

    const snap = await db.collection('Synchronisations')
        .where('Parent', '==', parent)
        .where('Project', '==', project)
        .where('Type', '==', type)
        .get();

    return snap.docs.some((doc) => {
        const data = doc.data();
        if (isDeletedStatus(data.Status)) return false;
        return data[sourceField] === sourceId;
    });
};

export default existsSync;
export { isDeletedStatus };
